import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideDownload } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDialogImports } from '@spartan-ng/helm/dialog';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { HlmTypographyImports } from '@spartan-ng/helm/typography';

/** The server-rendered demo voucher: the PNG to look at, the PDF to download. */
@Component({
  selector: 'app-preview-dialog',
  standalone: true,
  imports: [NgIcon, HlmButtonImports, HlmDialogImports, HlmSpinnerImports, HlmTypographyImports],
  providers: [provideIcons({ lucideDownload })],
  templateUrl: './preview-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewDialogComponent {
  readonly open = input(false);
  readonly imageUrl = input<string | null>(null);
  readonly loading = input(false);
  readonly downloading = input(false);
  readonly error = input<string | null>(null);
  /** Product designs preview with the company's first product, or a demo product. */
  readonly productDesign = input(false);

  readonly close = output<void>();
  readonly download = output<void>();
  readonly retry = output<void>();

  onDialogState(state: 'open' | 'closed') {
    if (state === 'closed' && this.open()) this.close.emit();
  }
}
